export default __webpack_public_path__ + "static/media/MarqueeLogo.a0ef96c3.svg";